import { render } from "./VoucherReplenishmentAlert.vue?vue&type=template&id=58a3d47d&scoped=true"
import script from "./VoucherReplenishmentAlert.vue?vue&type=script&lang=js"
export * from "./VoucherReplenishmentAlert.vue?vue&type=script&lang=js"

import "./VoucherReplenishmentAlert.vue?vue&type=style&index=0&id=58a3d47d&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\Erp Con api propia\\ERP CON MI-API\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a3d47d"]])

export default __exports__